import React, { useState, useEffect } from 'react'
import axios from "axios";

import { Loading } from '../../components';
import { Alert } from '../../components';
import { AjaxForm } from '../../forms';
import { FeatureAmount, FeatureToggle } from '../atoms';
import { features } from '../../contexts/FeatureGating';

import './shopify-settings.scss';

const loadInitialValues = async (setInitialValues, setLoading, setError) => {
  try {
    const response = await axios.get("/api/feature-quotas");

    setInitialValues(response.data?.features);
  } catch (err) {
    setError(err.message);
  } finally {
    setLoading(false);
  }
};

export function ShopifySettings() {
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    loadInitialValues(setInitialValues, setLoading, setError);
  }, []);

  if (loading) {
    return <Loading />;
  }

  const clearFlags = () => {
    setSuccess('');
    setError('');
  }

  const submitForm = async (data) => {
    clearFlags();

    try {
      await axios.put("/api/feature-quotas", {
        features: data,
      });

      setSuccess('Changes successfully saved');
      setTimeout(() => clearFlags(), 5 * 1000);
    } catch (err) {
      setError(err.message);
      setTimeout(() => clearFlags(), 15 * 1000);
    }
  }

  return (
    <section className="ft-quota-settings">
      {success && (
        <Alert type="success" message="Changes successfully saved" />
      )}

      {error && (
        <Alert type="error" message="Something went wrong" description={error} />
      )}

      <AjaxForm
        submitLabel='Save settings'
        submitAction={(data) => submitForm(data)}
        submitContainerClassName="ft-quota-settings__actions"
        initialValues={initialValues}
      >
        {(props) => {
          if (!initialValues) {
            return null;
          }

          return (
            <div className="ft-quota-settings__table">
              <div className="row header">
                <div className="col-feature">
                  Subscription features
                </div>
                <div className="col-plan">
                  Freemium
                </div>
                <div className="col-plan">
                  Club
                </div>
                <div className="col-plan">
                  Black
                </div>
              </div>

              <FeatureAmount feature={features.ORDER_REQUESTS} label="Total # of Order Requests per month" values={props.values[features.ORDER_REQUESTS]} />
              <FeatureAmount feature={features.SELL_REQUESTS} label="Total # of Sell Requests per month" values={props.values[features.SELL_REQUESTS]} />
              <FeatureToggle feature={features.MARKETPLACE_ACCESS} label="Direct Marketplace Button" values={props.values[features.MARKETPLACE_ACCESS]} />
              <FeatureToggle feature={features.PART_EXCHANGE} label="Part Exchange" values={props.values[features.PART_EXCHANGE]} />
              <FeatureToggle feature={features.CLIENT_PRODUCT_REQUEST} label="Client Product Request" values={props.values[features.CLIENT_PRODUCT_REQUEST]} />
              <FeatureAmount feature={features.LISTINGS} label="Total # of Listings Creation per month" values={props.values[features.LISTINGS]} />
              <FeatureToggle feature={features.SHARE_WHATSAPP} label="Share WhatsApp Listing" values={props.values[features.SHARE_WHATSAPP]} />
              <FeatureToggle feature={features.ADD_PRODUCT} label="Form to add product to Library" values={props.values[features.ADD_PRODUCT]} />
            </div>
          );
        }}
      </AjaxForm>
    </section>
  );
}
